import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core';
import { Refresh as RefreshIcon, RemoveRedEye as ViewIcon } from '@material-ui/icons';
import { FHETable } from 'data/components';
import { Toastr } from 'data/common';
import { getUsers } from '../../data/Users/actions';
import selectors from './selectors';

class User extends PureComponent {
    static propTypes = {
        homes: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        users: PropTypes.object.isRequired,
        getUsers: PropTypes.func.isRequired,
        profile: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { initialized } = props;
        this.state = {
            loading: !initialized
        };
    }

    componentDidMount() {
        const { initialized } = this.props;
        if (!initialized) this.refreshUsers();
    }

    refreshUsers = () => {
        const { getUsers } = this.props;
        this.setState({ loading: true });
        return getUsers()
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    navigateToDetail = rowData => {
        const { history } = this.props;
        return history.push({ pathname: `home/detail/${rowData.homeId}` });
    };

    renderActions = memoizeOne(profile => {
        const { history } = this.props;

        const userRight = profile.getIn(['user_rights', history.environment], []);
        let actions = {
            row: [],
            toolbar: [
                {
                    icon: RefreshIcon,
                    tooltip: Translator.translate(`generic.user.table.globalAction.refresh.tooltip`),
                    onClick: this.refreshUsers
                }
            ]
        };
        if (profile.get('admin') || userRight.includes('userDetails')) {
            actions.row.push({
                icon: ViewIcon,
                tooltip: Translator.translate(`general.showDetail`),
                onClick: this.navigateToDetail
            });
        }
        return actions;
    });

    renderData = memoizeOne(users => {
        const { homes } = this.props;
        let result = [];

        users.map(user => {
            result.push({
                homeId: user.get('homeId'),
                homeLabel: homes.getIn([user.get('homeId').toString(), 'label'], ''),
                lastname: user.get('lastname'),
                firstname: user.get('firstname'),
                email: user.get('email'),
                telPort: user.get('telPort'),
                telFixe: user.get('telFixe')
            });
        });
        return result;
    });
    renderColumns = memoizeOne(profile => {
        const { history } = this.props;

        return [
            {
                title: Translator.translate('general.table.column.homeId'),
                name: 'homeId',
                width: 100,
                fixedLeft: true
            },
            {
                title: Translator.translate('general.table.column.homeLabel'),
                name: 'homeLabel',
                action: (profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeDetails')) && {
                    onClick: this.navigateToDetail,
                    tooltip: Translator.translate(`general.showHome`)
                }
            },
            {
                title: Translator.translate('general.table.column.lastname'),
                name: 'lastname'
            },
            {
                title: Translator.translate('general.table.column.firstname'),
                name: 'firstname'
            },
            {
                title: Translator.translate('general.table.column.email'),
                name: 'email'
            },
            {
                title: Translator.translate('general.table.column.telPort'),
                name: 'telPort'
            },
            {
                title: Translator.translate('general.table.column.telFixe'),
                name: 'telFixe'
            }
        ];
    });

    render() {
        const { loading } = this.state;
        const { users, profile, history } = this.props;

        return (
            <FHETable
                idTable="userList"
                columns={this.renderColumns(profile)}
                data={this.renderData(users)}
                actions={this.renderActions(profile)}
                title={Translator.translate(`generic.user.table.title`)}
                emptyDataSourceMessage={Translator.translate(`generic.user.table.body.emptyDataSourceMessage`)}
                isLoading={loading}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    return {
        homes: selectors.getHomes(state),
        profile: state.data.user,
        users: state.environments[history.environment].data.Users.get('list'),
        initialized: selectors.getUsersInitialized(state)
    };
}

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { getUsers }), dispatch)
    )(withTheme(User))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/User/index.js